'use strict';
/*
    Check whether the tenants email address is valid in the booking form
 */
namespace TR {
    type BookingService = Core.Booking.BookingService;
    class EmailAllowed {

        constructor(private $q,
                    private bookingService : BookingService) {}

        init(scope: any, el: any, attr: any, ctrl: any) {
            ctrl.$asyncValidators.emailAllowed = (modelValue) => {
                if (ctrl.$isEmpty(modelValue)) {
                    return this.$q.resolve();
                }
                //do fetch from some service here
                return this.bookingService.checkValidEmail(modelValue);
            };
        }
    }

    angular
        .module('TR')
        .directive('emailAllowed', (): ng.IDirective => {
            return {
                restrict: 'A',
                controller: EmailAllowed,
                controllerAs: 'ea',
                require: 'ngModel',
                link: (scope: any, el: any, attr: any, ctrl: any) => {
                    return scope.ea.init(scope, el, attr, ctrl);
                }
            };
        });
}
